import React, { useEffect, useState } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';
import { useParams, Link } from 'react-router-dom';
import ProductImages from './ProductImages'; 
import { portfolioItems, tabData } from './data';

export default function ProductDetails() {
  const { id } = useParams();
  const [activeTab, setActiveTab] = useState('tab-1');

  useEffect(() => {
    AOS.init({ duration: 1000 });
  }, []);

  const product = portfolioItems.find(item => item.img === id);

  const selectedProduct = portfolioItems.find(p => p.img === id);

  const imagesArray = [
    selectedProduct.image.MainImage,
    selectedProduct.image['3DImage'],
    selectedProduct.image['2Diamge'],
  ];

  // Define the tabs with unique IDs, labels, and content
  const tabs = Object.entries(tabData).map(([tabId, tabInfo]) => ({
    id: tabId,
    label: tabInfo.label,
    content: Object.values(tabInfo.details),
  }));

  // State to track active tab

  return (
    <>
      <div className="page-title light-background">
        <div className="container d-lg-flex justify-content-between align-items-center">
          {/* <h1 className="mb-2 mb-lg-0">Product Category</h1> */}
          <nav className="breadcrumbs">
            <ol>
              <li><Link to="/">Home</Link></li>
              <li><Link to="/product">Products</Link></li>
              <li className="current">Product Detail</li>
            </ol>
          </nav>
        </div>
      </div>

      <section id="about-2" className="about-2 section">
        <div className="container" data-aos="fade-up">
          <div className="row g-4 g-lg-5" data-aos="fade-up" data-aos-delay="200">
            <div className="col-lg-5">
              <div className="about-img">
              <ProductImages images={imagesArray} />
              </div>
            </div>

            <div className="col-lg-7">
              <h5 className="pt-0">
                Product information:
              </h5>

              <div className="portfolio-info aos-init aos-animate" data-aos="fade-up" data-aos-delay="200">
              <ul>
                  <li><strong>Model Name</strong> : {product.title}</li>
                  {product.Weight && (<li><strong>Weight</strong> : {product.Weight}</li>)}
                  {product.Length && (<li><strong>Length</strong> : {product.Length}</li>)}
                  {product.ProfileSize && (<li><strong>Profile Size</strong> : {product.ProfileSize}</li>)}
                  {product.Det && (<li><strong>{product.Det}</strong></li>)}
                  {product.Det1 && (<li>{product.Det1}</li>)}
                  {product.Det2 && (<li>{product.Det2}</li>)}
                  {product.Det3 && (<li>{product.Det3}</li>)}
              </ul>
            </div>

              <ul className="nav nav-pills mt-3 mb-3" id="pills-tab" role="tablist">
                {tabs.map(({ id, label }) => (
                  <li key={id} className="nav-item" role="presentation">
                    <button
                      className={`nav-link ${activeTab === id ? 'active' : ''}`}
                      id={`${id}-tab`}
                      data-bs-toggle="pill"
                      data-bs-target={`#${id}`}
                      type="button"
                      role="tab"
                      aria-controls={id}
                      aria-selected={activeTab === id}
                      onClick={() => setActiveTab(id)}
                    >
                      {label}
                    </button>
                  </li>
                ))}
              </ul>

              <div className="tab-content" id="pills-tabContent">
                {tabs.map(({ id, content }) => (
                  <div
                    key={id}
                    className={`tab-pane fade ${activeTab === id ? 'show active' : ''}`}
                    id={id}
                    role="tabpanel"
                    aria-labelledby={`${id}-tab`}
                  >
                    {content.map((line, idx) => (
                      <div key={idx} className="d-flex align-items-center mt-4">
                        <i className="bi bi-check2"></i>
                        <h4>{line}</h4>
                      </div>
                    ))}
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}